import ChangePasswordPage from './presentation/auth/ChangePasswordPage';
import ForgotPasswordPage from './presentation/auth/ForgotPasswordPage';
import LoginPage from './presentation/auth/LoginPage';
import OtpVerifyPage from './presentation/auth/OtpVerifyPage';
import ResetPasswordPage from './presentation/auth/ResetPasswordPage';

export {
  ChangePasswordPage,
  ForgotPasswordPage,
  LoginPage,
  OtpVerifyPage,
  ResetPasswordPage,
};

export const iamRouteEntries = {
  rolesList: () => import('./presentation/roles/RolesListPage'),
  roleEditor: () => import('./presentation/roles/RoleEditorPage'),
  usersList: () => import('./presentation/users/UsersListPage'),
  userCreate: () => import('./presentation/users/UserCreateWizardPage'),
  userDetail: () => import('./presentation/users/UserDetailPage'),
  userEdit: () => import('./presentation/users/UserEditFormPage'),
  profile: () => import('./presentation/profile/ProfilePage'),
} as const;